export interface FAQItem {
  question: string;
  answer: string;
}

export interface FAQAccordionProps {
  title: string;
  items: readonly FAQItem[];
  language?: "en" | "hi";
}

export default function FAQAccordion({ title, items, language = "en" }: FAQAccordionProps) {
  const headingClassName =
    language === "hi"
      ? "mb-4 mt-10 font-hi text-title-hi font-bold text-text-primary"
      : "mb-4 mt-10 font-serif text-title font-bold text-text-primary";
  const bodyClassName = language === "hi" ? "font-hi text-body-hi" : "text-body";
  return (
    <>
      <h2 className={headingClassName}>{title}</h2>
      <div className="space-y-3">
        {items.map((item) => (
          <details
            key={item.question}
            className="group rounded-xl border border-border-default bg-surface-raised"
          >
            <summary
              className={`flex min-h-11 cursor-pointer list-none items-center justify-between gap-4 p-4 font-bold text-text-primary ${bodyClassName}`}
            >
              <span>{item.question}</span>
              <span
                aria-hidden
                className="shrink-0 text-subtitle text-text-primary transition-transform group-open:rotate-45"
              >
                +
              </span>
            </summary>
            <p
              className={`border-t border-border-subtle px-4 pb-4 pt-3 leading-relaxed text-text-secondary ${bodyClassName}`}
            >
              {item.answer}
            </p>
          </details>
        ))}
      </div>
    </>
  );
}
